import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import AiTextButton from '../AiTextButton/AiTextButton';
import { ChatBox } from '../ChatBox/ChatBox';
import { $createTextNode, $getRoot, $getSelection, $isRangeSelection } from 'lexical';
import './AiChatWrapper.css';

// The same sparkle the document panel uses for its AI summary action.
const SparkleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true">
    <path d="M12 4l1.6 4.4L18 10l-4.4 1.6L12 16l-1.6-4.4L6 10l4.4-1.6z" />
    <path d="M19 15l.8 1.9L21.7 17.7l-1.9.8L19 20.4l-.8-1.9-1.9-.8 1.9-.8z" />
  </svg>
);

const AiChatWrapper = () => {
  const [aiModalVisibility, setAiModalVisibility] = useState(false);
  const [isOpenAi, setIsOpenAi] = useState(false);
  const editor = useSelector((state) => state.editor.lexicalEditor);
  const isReadOnly = useSelector((state) => state.editor.isReadOnly);
  const isUiLocked = useSelector((state) => state.editor.isUiLocked);
  const conflictPreviewVerion = useSelector((state) => state.editor.conflictPreviewVerion);

  // While a cached preview is on screen and the fresh document is still loading
  // in the background the whole UI is read-only, so AI generation must be off too.
  const interactionsDisabled = isReadOnly || isUiLocked;

  const showAiText = (text) => {
    if (editor) {
      editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          selection.insertText(text);
        } else {
          const rootNode = $getRoot();
          rootNode.append($createTextNode(text));
        }
      });
    }
  };

  if (conflictPreviewVerion) return null;

  return (
    <div className='ai-chat-wrapper'>
      <Button className='AI-icon' title='Generate with AI' type="text" icon={<SparkleIcon />} onClick={() => { if (!interactionsDisabled) setAiModalVisibility(true) }} disabled={interactionsDisabled} />
      <AiTextButton
        isOpen={isOpenAi}
        setIsOpenAi={setIsOpenAi}
        showAiText={showAiText}
        setAiModalVisibility={setAiModalVisibility}
        aiModalVisibility={aiModalVisibility}
      />
      <div className='chatbox-container'>
        <ChatBox />
      </div>
    </div>
  );
};

export default AiChatWrapper;